<template>
    <transition name="fade">
      <div class="downloadDialog" v-show="visible">
        <div class="tips">
          <img src="./img/qcode.png" alt="">
          <i class="iconfont icon-guanbi close" @click="hide"></i>
        </div>
      </div>
    </transition>
</template>

<script>
    import Dialog from '@/utils/mixin/Dialog.js'
    export default {
      mixins:[Dialog],
      name: "downloadDialog",

    }
</script>

<style scoped lang="less">
.downloadDialog {
  position :fixed;
  z-index :10000;
  top :0;
  left :0;
  width :100%;
  height :100%;
  overflow: auto;
  color: white;
  background:  rgba(0, 0, 0, 0.5);
  .tips {
    position: absolute;
    width: 4.8rem;
    height: 5rem;
    left: 50%;
    top: 40%;
    margin-top: -2.4rem;
    margin-left: -2.4rem;
    background-image: url("./img/Popup.png");
    background-size: 100%;
    border-radius: .16rem;
    img {
      width: 2.28rem;
      position: absolute;
      left: 50%;
      margin-left: -1.14rem;
      margin-top: 1.8rem;
    }
    .close {
      position: absolute;
      top: 110%;
      left: 50%;
      font-size: .52rem;
      margin-left: -.26rem;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/download/downloadDialog.vue